import { Progress } from "antd";
import './styles.scss';

interface ProgressItemProps {
  title: string;
  description: string;
  percent: number;
}

const ProgressItem = ({
  title,
  description,
  percent,
}: ProgressItemProps) => {
  return (
    <div className="progress-item">
      <div className="progress-title">
        {title}
      </div>

      <div className="progress-description">
        {description}
      </div>

      <Progress
        percent={percent}
        showInfo={false}
        strokeColor={{
          "0%": "#1890FF",
          "100%": "#b6d8f8",
        }}
        strokeWidth={10}
        trailColor="#F5F5F5"
      />
    </div>
  );
};

export default ProgressItem